import http from "../http-common";

class WorkshopService {
  createWorkshop(data) {
    return http.post("workshop/create", data);
  }
  getWorkshops() {
    return http.get("workshop/list");
  }
  getWorkshopById(id) {
    return http.get("workshop/detail", { params: { id } });
  }
  updateWorkshop(data) {
    return http.put("workshop/update", data);
  }
  deleteWorkshop(data) {
    return http.delete("workshop/delete", { params: data });
  }
  getWorkshopRegistrations(params) {
    return http.get("workshop/registration/list", { params });
  }
}

export default new WorkshopService();